import { useEffect, useState } from "react";
import {
  LuAtom,
  LuBot,
  LuBotMessageSquare,
  LuBrain,
  LuBrainCog,
  LuCpu,
  LuOrbit,
  LuScanFace,
  LuSparkles,
  LuWandSparkles,
} from "react-icons/lu";
import {
  RiAiGenerate,
  RiBrainFill,
  RiBrainLine,
  RiChatAiLine,
  RiChatSmile3Line,
  RiMagicLine,
  RiRobot2Fill,
  RiRobot2Line,
  RiRobot3Line,
  RiShining2Line,
  RiSparkling2Line,
  RiSparklingFill,
} from "react-icons/ri";
import {
  TbAi,
  TbAtom2,
  TbBrain,
  TbCpu,
  TbMessageChatbot,
  TbRobot,
  TbRobotFace,
  TbSparkles,
} from "react-icons/tb";
import { BsCpu, BsRobot, BsStars } from "react-icons/bs";
import { PiAtom, PiBrain, PiRobot, PiSparkle } from "react-icons/pi";
import { HiCpuChip, HiOutlineSparkles, HiSparkles } from "react-icons/hi2";
import { GiArtificialHive, GiArtificialIntelligence, GiBrain } from "react-icons/gi";
import { IoSparkles } from "react-icons/io5";
import {
  MdAssistant,
  MdAutoAwesome,
  MdChat,
  MdChatBubble,
  MdHeadsetMic,
  MdOutlineSmartToy,
  MdPsychology,
  MdQuestionAnswer,
  MdSmartToy,
  MdSupportAgent,
} from "react-icons/md";
import { FaBrain, FaRobot, FaWandMagicSparkles } from "react-icons/fa6";

// The approved Aegis AI icon set (the 50 icons from the icon-picker review).
export const ALL_ASSIST_ICONS = [
  // Robots
  { value: "RiRobot3Line", label: "Robot Bust", category: "Robots", Icon: RiRobot3Line },
  { value: "LuBot", label: "Bot", category: "Robots", Icon: LuBot },
  { value: "RiRobot2Line", label: "Robot Outline", category: "Robots", Icon: RiRobot2Line },
  { value: "RiRobot2Fill", label: "Robot Solid", category: "Robots", Icon: RiRobot2Fill },
  { value: "TbRobot", label: "Robot", category: "Robots", Icon: TbRobot },
  { value: "TbRobotFace", label: "Robot Face", category: "Robots", Icon: TbRobotFace },
  { value: "BsRobot", label: "Friendly Robot", category: "Robots", Icon: BsRobot },
  { value: "PiRobot", label: "Soft Robot", category: "Robots", Icon: PiRobot },
  { value: "FaRobot", label: "Robot Assistant", category: "Robots", Icon: FaRobot },
  { value: "LuScanFace", label: "Face Scan", category: "Robots", Icon: LuScanFace },

  // Chat assistants
  { value: "LuBotMessageSquare", label: "Bot Message", category: "Chat Assistants", Icon: LuBotMessageSquare },
  { value: "TbMessageChatbot", label: "Chatbot", category: "Chat Assistants", Icon: TbMessageChatbot },
  { value: "RiChatAiLine", label: "AI Chat", category: "Chat Assistants", Icon: RiChatAiLine },
  { value: "RiChatSmile3Line", label: "Friendly Chat", category: "Chat Assistants", Icon: RiChatSmile3Line },
  { value: "MdAssistant", label: "Assistant", category: "Chat Assistants", Icon: MdAssistant },

  // Brains
  { value: "LuBrain", label: "Brain", category: "Brains", Icon: LuBrain },
  { value: "LuBrainCog", label: "Brain Cog", category: "Brains", Icon: LuBrainCog },
  { value: "RiBrainLine", label: "Brain Outline", category: "Brains", Icon: RiBrainLine },
  { value: "RiBrainFill", label: "Brain Solid", category: "Brains", Icon: RiBrainFill },
  { value: "TbBrain", label: "Neural Brain", category: "Brains", Icon: TbBrain },
  { value: "PiBrain", label: "Soft Brain", category: "Brains", Icon: PiBrain },
  { value: "MdPsychology", label: "AI Mind", category: "Brains", Icon: MdPsychology },
  { value: "FaBrain", label: "Brain Bold", category: "Brains", Icon: FaBrain },
  { value: "GiBrain", label: "Brain Detail", category: "Brains", Icon: GiBrain },

  // Sparkles & magic
  { value: "LuSparkles", label: "Sparkles", category: "Sparkles & Magic", Icon: LuSparkles },
  { value: "LuWandSparkles", label: "Magic Wand", category: "Sparkles & Magic", Icon: LuWandSparkles },
  { value: "RiSparklingFill", label: "Sparkling Solid", category: "Sparkles & Magic", Icon: RiSparklingFill },
  { value: "RiSparkling2Line", label: "Sparkling", category: "Sparkles & Magic", Icon: RiSparkling2Line },
  { value: "RiMagicLine", label: "Magic", category: "Sparkles & Magic", Icon: RiMagicLine },
  { value: "RiShining2Line", label: "Shining", category: "Sparkles & Magic", Icon: RiShining2Line },
  { value: "TbSparkles", label: "Twin Sparkles", category: "Sparkles & Magic", Icon: TbSparkles },
  { value: "BsStars", label: "Stars", category: "Sparkles & Magic", Icon: BsStars },
  { value: "PiSparkle", label: "Sparkle", category: "Sparkles & Magic", Icon: PiSparkle },
  { value: "MdAutoAwesome", label: "AI Sparkle", category: "Sparkles & Magic", Icon: MdAutoAwesome },
  { value: "FaWandMagicSparkles", label: "Magic AI", category: "Sparkles & Magic", Icon: FaWandMagicSparkles },
  { value: "HiOutlineSparkles", label: "Sparkles Outline", category: "Sparkles & Magic", Icon: HiOutlineSparkles },
  { value: "HiSparkles", label: "Sparkles Solid", category: "Sparkles & Magic", Icon: HiSparkles },
  { value: "IoSparkles", label: "Glow Sparkles", category: "Sparkles & Magic", Icon: IoSparkles },

  // Chips & science
  { value: "TbAi", label: "AI", category: "Chips & Science", Icon: TbAi },
  { value: "RiAiGenerate", label: "AI Generate", category: "Chips & Science", Icon: RiAiGenerate },
  { value: "LuCpu", label: "Processor", category: "Chips & Science", Icon: LuCpu },
  { value: "TbCpu", label: "CPU", category: "Chips & Science", Icon: TbCpu },
  { value: "BsCpu", label: "Chip", category: "Chips & Science", Icon: BsCpu },
  { value: "HiCpuChip", label: "Microchip", category: "Chips & Science", Icon: HiCpuChip },
  { value: "LuAtom", label: "Atom", category: "Chips & Science", Icon: LuAtom },
  { value: "TbAtom2", label: "Atom Orbit", category: "Chips & Science", Icon: TbAtom2 },
  { value: "PiAtom", label: "Soft Atom", category: "Chips & Science", Icon: PiAtom },
  { value: "LuOrbit", label: "Orbit", category: "Chips & Science", Icon: LuOrbit },
  { value: "GiArtificialIntelligence", label: "Artificial Intelligence", category: "Chips & Science", Icon: GiArtificialIntelligence },
  { value: "GiArtificialHive", label: "AI Hive", category: "Chips & Science", Icon: GiArtificialHive },
];

const findIcon = (value) => ALL_ASSIST_ICONS.find((opt) => opt.value === value);

// Primary quick icons shown on the main form row
export const DEFAULT_ASSIST_ICONS = [
  "RiRobot3Line",
  "LuBotMessageSquare",
  "TbMessageChatbot",
  "LuBrain",
  "LuSparkles",
  "RiChatSmile3Line",
  "TbAi",
  "MdAssistant",
].map(findIcon);

export const ASSIST_ICON_CATEGORIES = [
  "All",
  "Robots",
  "Chat Assistants",
  "Brains",
  "Sparkles & Magic",
  "Chips & Science",
];

export const ASSIST_ICON_OPTIONS = ALL_ASSIST_ICONS;

// Icons from the previous icon set. Not offered in the picker any more, but widgets
// saved with them must keep rendering the same icon.
const LEGACY_ASSIST_ICONS = [
  { value: "MdSupportAgent", label: "Support Agent", Icon: MdSupportAgent },
  { value: "MdSmartToy", label: "Smart Toy", Icon: MdSmartToy },
  { value: "MdOutlineSmartToy", label: "Robot Outline", Icon: MdOutlineSmartToy },
  { value: "MdChat", label: "Chat Bubble", Icon: MdChat },
  { value: "MdChatBubble", label: "Chat Filled", Icon: MdChatBubble },
  { value: "MdHeadsetMic", label: "Headset", Icon: MdHeadsetMic },
  { value: "MdQuestionAnswer", label: "Q&A", Icon: MdQuestionAnswer },
];

const ICON_MAP = [...LEGACY_ASSIST_ICONS, ...ALL_ASSIST_ICONS].reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});

// An uploaded logo, wrapped as an icon component so it drops in wherever a preset icon renders. Unlike a
// glyph it ignores `size` and fills its badge (avatar, chip, launcher) as a cropped circle; the inline size
// wins over the `svg` sizing CSS meant for glyphs. Every place that renders it uses a fixed-size badge.
// Cached per URL so re-renders keep the same component type instead of remounting the image.
const LOGO_ICON_CACHE_LIMIT = 100;
const LOGO_FILL_STYLE = { width: "100%", height: "100%", display: "block", clipPath: "circle(50%)" };
const logoIconCache = new Map();
// The widget's minimize/maximize animation draws a copy of the window as an SVG image, and an SVG image
// never loads external URLs. So the logo is inlined as a data: URL once fetched; until then (or if the
// fetch fails) the plain URL is used.
const logoDataUrls = new Map();
// The icon is cached as immutable; a copy cached without CORS headers (loaded by <image> before the API
// sent them on every response) fails a CORS fetch, so retry once bypassing and replacing that copy.
const fetchLogo = (url) => fetch(url).catch(() => fetch(url, { cache: "reload" }));
const loadLogoDataUrl = (url) => {
  if (!logoDataUrls.has(url)) {
    logoDataUrls.set(url, fetchLogo(url)
      .then((response) => (response.ok ? response.blob() : Promise.reject(new Error(response.status))))
      .then((blob) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      }))
      .catch(() => {
        logoDataUrls.delete(url);
        return null;
      }));
  }
  return logoDataUrls.get(url);
};
const getLogoIconComponent = (url) => {
  let LogoIcon = logoIconCache.get(url);
  if (!LogoIcon) {
    if (logoIconCache.size >= LOGO_ICON_CACHE_LIMIT) logoIconCache.clear();
    LogoIcon = ({ className, style }) => {
      const [dataUrl, setDataUrl] = useState(null);
      useEffect(() => {
        let active = true;
        loadLogoDataUrl(url).then((value) => {
          if (active && value) setDataUrl(value);
        });
        return () => {
          active = false;
        };
      }, []);
      return (
        <svg viewBox="0 0 24 24" className={`aegis-logo-icon ${className || ""}`.trim()} style={{ ...LOGO_FILL_STYLE, ...style }} aria-hidden="true">
          <image href={dataUrl || url} width="24" height="24" preserveAspectRatio="xMidYMid slice" />
        </svg>
      );
    };
    // Lets badges drop their brand-colour background behind a logo.
    LogoIcon.isLogo = true;
    logoIconCache.set(url, LogoIcon);
  }
  return LogoIcon;
};

export const getAssistIconComponent = (value, logoUrl) =>
  logoUrl ? getLogoIconComponent(logoUrl) : ICON_MAP[value]?.Icon || RiRobot3Line;

export const getAssistIconLabel = (value) => ICON_MAP[value]?.label || "Robot Bust";

export const ASSIST_POSITION_OPTIONS = [
  { value: "bottom-right", label: "Bottom Right" },
  { value: "bottom-left", label: "Bottom Left" },
  { value: "top-right", label: "Top Right" },
  { value: "top-left", label: "Top Left" },
];

export const getAssistPositionLabel = (value) => {
  const match = ASSIST_POSITION_OPTIONS.find((opt) => opt.value === value);
  return match ? match.label : "Bottom Right";
};
